
import { 
  AMC_APPLICATION_API_STATUS,
  AMC_REFERENCE_DATA_SET_VALUE, 
  AMC_VEHICLE_MAKE_REFERENCE_DATA_SET_VALUE, 
  AMC_VEHICLE_MODEL_REFERENCE_DATA_SET_VALUE
}  from '../../actions/allSureMotorClaim/referenceData'


export const initReferenceData= {
  apiStatus: null,
  referenceNumber: null,
  applicationData: {
    vehicleMakeData:{},
    vehicleModelData: {},
  },
};

export default (state = initReferenceData, action) => {
    
  switch (action.type) {
    case AMC_REFERENCE_DATA_SET_VALUE:
      return {
        ...state,
        [action.value.type]: action.value.value,
      };
    case AMC_VEHICLE_MAKE_REFERENCE_DATA_SET_VALUE:
          return {
            ...state,
            applicationData: {
              ...state.applicationData,
              vehicleMakeData: action.value,
            },
          };
    case AMC_VEHICLE_MODEL_REFERENCE_DATA_SET_VALUE:
          return {
            ...state,
            applicationData: {
              ...state.applicationData,
              vehicleModelData: action.value,
            },
          };
          
    case AMC_APPLICATION_API_STATUS:
      return {
        ...state,
        [action.value.type]: action.value.value,
      };
    default:
    return state;
  }
};

